// extracted by mini-css-extract-plugin
export default {"icon":"statCardIcon_icon__HNpi3","graphic":"statCardIcon_graphic__knNwb"};